import 'jquery';

export default {
  init() {
    console.log('testing homes');

    // const BASEURL = 'https://simplelifstg.wpengine.com/';

    (function($) {

      let btnSwitchMap = document.querySelector('.btn__show-map');
      btnSwitchMap.addEventListener('click', function (e){
        e.preventDefault()


        const mapArea = document.querySelector('.map-area');
        const cardView = document.querySelector('.card-view');
        const mapTitle = document.querySelector('.map_title');
        const mapIcon = document.querySelector('.map_icon');

        // $( ".map-area" ).toggle('slow');
        $(".map-area, .card-view").slideToggle();

        if(mapTitle.innerHTML == 'Map View') {
          mapTitle.innerHTML = 'Grid View'
        }else {
          mapTitle.innerHTML = 'View Map'
        }

        if(mapIcon.innerHTML == '<i class="fa-solid fa-location-dot"></i>'){
          mapIcon.innerHTML = '<i class="fas fa-border-all"></i>'
        }else {
          mapIcon.innerHTML = '<i class="fa-solid fa-location-dot"></i>'
        }

      })

      let btnSwitchMap1 = document.querySelector('.btn__show-map1');
      btnSwitchMap1.addEventListener('click', function (e){
        e.preventDefault()


        const mapArea = document.querySelector('.map-area');
        const cardView = document.querySelector('.card-view');
        const mapTitle = document.querySelector('.btn_show-map_label');
        const mapIcon = document.querySelector('.btn_show-map_icon');



        // $( ".map-area" ).toggle('slow');
        $(".map-area, .card-view").slideToggle();

        if(mapTitle.innerHTML == 'View Map') {
          mapTitle.innerHTML = 'Grid View'
        }else {
          mapTitle.innerHTML = 'View Map'
        }

        if(mapIcon.innerHTML == '<i class="fa-solid fa-location-dot"></i>'){
          mapIcon.innerHTML = '<i class="fas fa-border-all"></i>'
        }else {
          mapIcon.innerHTML = '<i class="fa-solid fa-location-dot"></i>'
        }

      })

    })(jQuery);

    // const mainContentTitle = document.querySelector('.search_content_title');
    // let mainContentText = document.querySelector('.main-content__content');
    // const content = document.querySelector('.main-content__content');
    //
    // window.addEventListener('load', (event) => {
    //   const loadedContent = `${ BASEURL }/wp-json/wp/v2/area`;
    //   event.preventDefault();
    //   function loadMainContent() {
    //     $.ajax({
    //       url: loadedContent,
    //       dataType: 'json',
    //       success(res) {
    //         // $('.container-content').html(res);
    //         $.each(res, function(i, tx){
    //           // $('.container-content').html(res);
    //           if(tx.parent == 0) {
    //             mainContentTitle.innerText = tx.name;
    //             mainContentText.innerHTML =  tx.description;
    //           }
    //         })
    //       },
    //     })
    //   }
    //   loadMainContent()
    // });

    // function loadMainContent() {
    //   window.addEventListener('loaded', function (e){
    //     console.log('this is another test')
    //   })
    //   // if($('.facetwp-facet-location ').has('.checked')) {
    //   //
    //   // }
    // }
    // loadMainContent()

  },
};
